var map = {
  "./uk.json": [
    "982521",
    "375909"
  ],
  "./bg.json": [
    "617501",
    "604859"
  ],
  "./el.json": [
    "73751",
    "841133"
  ],
  "./en-pt.json": [
    "128037",
    "998173"
  ],
  "./sv.json": [
    "985153",
    "712868"
  ],
  "./sr.json": [
    "569635",
    "123038"
  ],
  "./lol.json": [
    "683482",
    "815140"
  ],
  "./fr.json": [
    "233703",
    "406938"
  ],
  "./nb.json": [
    "484297",
    "740012"
  ],
  "./uz.json": [
    "110369",
    "89058"
  ],
  "./ky.json": [
    "443113",
    "199026"
  ],
  "./pl.json": [
    "571405",
    "904871"
  ],
  "./ro.json": [
    "32401",
    "203363"
  ],
  "./ka.json": [
    "168911",
    "851319"
  ],
  "./hu.json": [
    "393861",
    "463460"
  ],
  "./de.json": [
    "836824",
    "251555"
  ],
  "./tr.json": [
    "191983",
    "800573"
  ],
  "./id.json": [
    "118135",
    "574423"
  ],
  "./lt.json": [
    "333187",
    "58231"
  ],
  "./lv.json": [
    "830582",
    "311264"
  ],
  "./es.json": [
    "292540",
    "220076"
  ],
  "./cs.json": [
    "337631",
    "947419"
  ],
  "./boxes.json": [
    "656251",
    "818976"
  ],
  "./sk.json": [
    "736687",
    "124404"
  ],
  "./nl.json": [
    "611165",
    "517067"
  ],
  "./accents.json": [
    "936345",
    "153393"
  ],
  "./ru.json": [
    "970142",
    "899830"
  ],
  "./zh-hans.json": [
    "961483",
    "393711"
  ],
  "./extra.json": [
    "696804",
    "670011"
  ],
  "./it.json": [
    "962698",
    "920201"
  ],
  "./hi.json": [
    "676921",
    "133041"
  ]
};
function webpackAsyncContext(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(function() {
      var e = new Error("Cannot find module '" + req + "'");
      e.code = 'MODULE_NOT_FOUND';
      throw e;
    });
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1]).then(function() {
    return __webpack_require__.t(id, 3 | 16);
  });
}

webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 574558;
module.exports = webpackAsyncContext;
